export const FILTER_PRICE_START = 0;

export const FILTER_PRICE_END = 2500000;

export const FILTER_PRICE_STEP = 5000;

export const FILTER_KM_START = 0;

export const FILTER_KM_END = 2500000;

export const FILTER_KM_STEP = 50000;

export const FILTER_REGISTRATION_YEAR_START = 1980;

export const FILTER_REGISTRATION_YEAR_END = Number(new Date().getFullYear());

export const FILTER_REGISTRATION_YEAR_STEP = 1;

export const FILTER_LENGTH_START = 3.5;

export const FILTER_LENGTH_END = 23;

export const FILTER_LENGTH_STEP = 0.5;

export const FILTER_WIDTH_START = 1.5;

export const FILTER_WIDTH_END = 5;

export const FILTER_WIDTH_STEP = 0.1;

export const FILTER_HEIGHT_START = 1.5;

export const FILTER_HEIGHT_END = 5;

export const FILTER_HEIGHT_STEP = 0.1;

export const FILTER_SEATS_VALUES = [5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140];

export const FILTER_FOLDING_SEATS_VALUES = [1, 2, 3, 4];

export const FILTER_COMPANION_SEATS_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const FILTER_WHEELCHAIR_PLACES_VALUES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];

export const FILTER_FUEL_TANK_CAPACITY_START = 100;

export const FILTER_FUEL_TANK_CAPACITY_END = 500;

export const FILTER_FUEL_TANK_CAPACITY_STEP = 100;

export const FILTER_POWER_START = 50;

export const FILTER_POWER_END = 650;

export const FILTER_POWER_STEP = 10;

export const FILTER_TOTAL_CAPACITY_START = 1;

export const FILTER_TOTAL_CAPACITY_END = 150;

export const FILTER_TOTAL_CAPACITY_STEP = 1;

export const FILTER_STANDING_PLACES_START = 1;

export const FILTER_STANDING_PLACES_END = 150;

export const FILTER_STANDING_PLACES_STEP = 1;

export const FILTER_OPENABLE_WINDOWS_START = 0;

export const FILTER_OPENABLE_WINDOWS_END = 18;

export const FILTER_OPENABLE_WINDOWS_STEP = 1;

export const FILTER_DISPLACEMENT_START = 1500;

export const FILTER_DISPLACEMENT_END = 18000;

export const FILTER_DISPLACEMENT_STEP = 500;

export const EMPTY_OPTION_VALUE = 'EMPTY_OPTION';
